import axios from 'axios';
import Cookie from 'cookies-js';
import jwt from 'jsonwebtoken';
import alertify from 'alertifyjs';
import config from '../../config/index';
import routes from '../../constants/routes';
import {
  UPDATE_KYC,
  SET_UPDATE_KYC_ERROR,
  DELETE_UPDATE_KYC_ERROR,
  KYC_IS_LOADING
} from '../types';

export const kyc = Kyc => ({
  type: UPDATE_KYC,
  Kyc
});

export const setKycError = error => ({
  type: SET_UPDATE_KYC_ERROR,
  error
});

export const deleteKycError = () => ({
  type: DELETE_UPDATE_KYC_ERROR
});

const kycIsLoading = () => ({
  type: KYC_IS_LOADING
});

const postKycRequest = kycDetails => (dispatch) => {
  dispatch(kycIsLoading());
  const token = Cookie.get('jwtToken');
  const decodeToken = jwt.decode(token);
  const { customerId } = decodeToken;
  const mainObj = {
    ...kycDetails,
    customerId
  };
  return axios.post(`${config.apiUrl}${routes.KYCFORM}`, mainObj, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  }).then((response) => {
    const { data } = response;
    if (data.isSuccessful) {
      dispatch(kyc(data));
      alertify
        .alert('You have succeeded in saving your KYC Details', () => {
          alertify.success('OK');
        }).setHeader('<em style="color: green; font-size: 18px; font-weight: bold;"> Congratulations! </em> ');
    } else {
      dispatch(setKycError(data.responseMessage));
    }
  }).catch(
    (error) => {
      const { data } = error.response;
      dispatch(kycIsLoading());
      dispatch(setKycError(data.responseMessage));
    }
  );
};

export default postKycRequest;
